import http from 'utils/http'

const getTermsConditions = () => http.get('/user/v1/terms-conditions')

const getPrivacyPolicy = () => http.get('/user/v1/privacy-policy')

export default {
  getTermsConditions,
  getPrivacyPolicy
}




// WEBPACK FOOTER //
// ./src/services/gdprService.js